import React from 'react';

import GraphemeSplitter from 'grapheme-splitter';

import { YatSprite } from '@pkg/components/YatSprite';

import './404Overlay.scss';

const graphemeSplitter = new GraphemeSplitter();

interface NotFoundYatListProps {
    emojiId?: string;
}

export const NotFoundYatList = ({ emojiId }: NotFoundYatListProps) => {
    return (
        <div className="not-found-overlay__yats">
            {emojiId
                ? graphemeSplitter.splitGraphemes(emojiId).map((emoji, index) => (
                      <div key={index.toString()} className="not-found-overlay__yats-yat">
                          <YatSprite emojiID={emoji} forceSprite={true} style={{ display: 'flex' }} />
                      </div>
                  ))
                : null}
        </div>
    );
};
